var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M13 2.67749H6C5.46957 2.67749 4.96086 2.8882 4.58579 3.26328C4.21071 3.63835 4 4.14706 4 4.67749V20.6775C4 21.2079 4.21071 21.7166 4.58579 22.0917C4.96086 22.4668 5.46957 22.6775 6 22.6775H18C18.5304 22.6775 19.0391 22.4668 19.4142 22.0917C19.7893 21.7166 20 21.2079 20 20.6775V9.67749M13 2.67749L20 9.67749M13 2.67749V9.67749H20",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.81f043009a96cd032a591835fab87e4d.svg";
export { ForwardRef as ReactComponent };